import React from 'react';
import { AlertCircle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
          <div className="max-w-md w-full neuro-base rounded-3xl p-8 text-center">
            <div className="neuro-pressed w-16 h-16 rounded-2xl mx-auto mb-4 flex items-center justify-center">
              <AlertCircle className="w-8 h-8 text-[#b09090]" />
            </div>
            <h2 className="text-xl font-light text-[#d0d0d0] mb-2">Something went wrong</h2>
            <p className="text-sm text-[#808080] mb-6">
              The app encountered an error. Please refresh the page to try again.
            </p>
            {this.state.error && (
              <details className="text-left mb-6">
                <summary className="text-xs text-[#707070] cursor-pointer mb-2">
                  Error details
                </summary>
                <pre className="text-xs text-[#606060] bg-[#0a0a0a] neuro-pressed rounded-xl p-3 overflow-auto max-h-40">
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
            <button
              onClick={() => window.location.reload()}
              className="neuro-base active:neuro-pressed rounded-2xl px-6 py-3 text-sm text-[#a0a0a0] smooth-transition hover:scale-105"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
